import {DomainObject} from 'shared/store';
import {computed, observable} from 'mobx';
import {dateSpan} from 'shared/tools';

class NmbrTaxDocument extends DomainObject {
  @observable id;
  @observable documentType;
  @observable taxYear;

  @computed get name() {
    return this.documentType.toUpperCase();
  }
}

export default NmbrTaxDocument;
